import { createAPI } from '@/request.js'
// 首页统计
export const statistics = data => createAPI('/api/home/statistics.mt', 'post', data)
export const statistics1 = data => createAPI('/api/home/statistics_1.mt', 'post', data)
export const statistics2 = data => createAPI('/api/home/statistics_2.mt', 'post', data)
export const statistics3 = data => createAPI('/api/home/statistics_3.mt', 'post', data)
export const statistics4 = data => createAPI('/api/home/statistics_4.mt', 'post', data)

export const merchantStatistics = data => createAPI('/api/home/merchant/statistics.mt', 'post', data)
// 商家订单统计明细表
export const excelMerchantStatistics = data => createAPI('/download/merchant/statistics/excel', 'get', data)
export const getTime = data => createAPI('/api/home/time/get.mt', 'post', data)
